// Centralização dos endpoints da API
const BASE_URL = "https://automation.floripasoftware.com.br/webhook";

export const ENDPOINTS = {
  // Usuários
  USUARIO_LIST: `${BASE_URL}/advserv_usuario_list`,
  USUARIO_DELETE: `${BASE_URL}/advserv_usuario_delete`,
  USUARIO_CREATE: `${BASE_URL}/advserv_usuario_create`,
  USUARIO_UPDATE: `${BASE_URL}/advserv_usuario_update`,
  USUARIO_LIST_EXECUTOR: `${BASE_URL}/advserv_usuario_list_executor`,
  USUARIO_PERMISSOES: `${BASE_URL}/advserv_usuario_permissoes`,

  // Departamentos
  DEPARTAMENTO_LIST: `${BASE_URL}/advserv_departamento_list`,
  DEPARTAMENTO_DELETE: `${BASE_URL}/advserv_departamento_delete`,
  DEPARTAMENTO_CREATE: `${BASE_URL}/advserv_departamento_create`,
  DEPARTAMENTO_UPDATE: `${BASE_URL}/advserv_departamento_update`,

  // Ordem de Serviço
  OS_READ: `${BASE_URL}/advserv_os_read`,
  OS_LIST: `${BASE_URL}/advserv_os_list`,
  OS_DELETE: `${BASE_URL}/advserv_os_delete`,
  OS_DISTRIBUIR: `${BASE_URL}/advserv_os_distribuir`,
  OS_ACEITAR: `${BASE_URL}/advserv_os_aceitar`,
  OS_GRAVAR: `${BASE_URL}/advserv_os_gravar`,
  OS_FINALIZAR: `${BASE_URL}/advserv_os_finalizar`,
  OS_CANCELAR: `${BASE_URL}/advserv_os_cancelar`,
  OS_ATRIBUIR: `${BASE_URL}/advserv_os_atribuir`,

  // Dashboard
  DASHBOARD_DEPARTAMENTOS: `${BASE_URL}/advserv_dashboard_departamentos`,
  DASHBOARD_CONTADORES: `${BASE_URL}/advserv_dashboard_contadores`,

  // Login
  LOGIN: `${BASE_URL}/advserv_login`,

  // QRCode
  QRCODE_GENERATE: `${BASE_URL}/advserv_qrcode_generate`,

  // Outros (exemplo dinâmico)
  SAVE_OS: (unidade: string) => `${BASE_URL}/saveos_${(unidade || '').toLowerCase()}`,
}; 